import React from "react";
import PropTypes from "prop-types";
import Select from "~components/Form/components/Select";

const HeaderNegotiations = ({
  optionFiliaisE,
  onChangeFilial,
  filialSelectE,
  optionGruposProduto,
  onChangeGrupoProduto,
  grupoProdutoSelect,
  optionProdutos,
  onChangeProduto,
  produtoSelect,
}) => {
  return (
    <div className="filter">
      <div className="filter-row">
        <div className="input-container">
          <Select
            name="filialId"
            placeholder=""
            label="Centro/Filial:"
            options={optionFiliaisE}
            noOptionsMessage="Centro/Filial não encontrado"
            onChange={(e) => onChangeFilial(e)}
            isDisabled={true}
            {...filialSelectE}
          />
        </div>

        <div className="input-container">
          <Select
            name="grupoProdutoId"
            label="Grupo de Produto:"
            placeholder="Grupo de Produto"
            onChange={(e) => onChangeGrupoProduto(e)}
            options={optionGruposProduto}
            isDisabled={true}
            {...grupoProdutoSelect}
          />
        </div>

        <div className="input-container">
          <Select
            name="produtoId"
            label="Produto:"
            placeholder="Produto"
            onChange={(e) => onChangeProduto(e)}
            options={optionProdutos}
            isDisabled={true}
            {...produtoSelect}
          />
        </div>
      </div>
    </div>
  );
};

HeaderNegotiations.propTypes = {
  optionFiliaisE: PropTypes.arrayOf(PropTypes.object),
  onChangeFilial: PropTypes.func.isRequired,
  filialSelectE: PropTypes.object,
  optionGruposProduto: PropTypes.arrayOf(PropTypes.object),
  onChangeGrupoProduto: PropTypes.func.isRequired,
  grupoProdutoSelect: PropTypes.object,
  optionProdutos: PropTypes.arrayOf(PropTypes.object),
  onChangeProduto: PropTypes.func.isRequired,
  produtoSelect: PropTypes.object,
};

export default HeaderNegotiations;
